import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ImageListPortalContainerWithControlErrorHandling } from './image-list-portal-container';
import { PerfMaxImageSuggestionCarousel } from './perf-max-image-suggestion-carousel';
import { ImageListSummaryCardDetails } from './image-list-card-details';
import ImageAssetsImg from '../media/image-assets.svg';

export const ImageListPortalContainerWithCarouselSection = ({
  expand,
  images,
  imageLimit,
  maxUploadNum,
  containerRef,
  containerState,
  addImageCallback,
  classes,
  isMultimediaAd,
  ...rest
}) => {
  const i18n = useContext(I18nContext);
  return (
    <ValidatedPanel
      key="images"
      title={<TextTitle
        titleKey={_TL_('Images')}
        topicKey="pop_BA_CampaignCreate_AudAds_Images"
        icon={ImageAssetsImg}
        iconAltText={i18n.getString(_TL_('"Images" panel\'s image'))}
        details={<ImageListSummaryCardDetails i18n={i18n} images={images} isLogos={false} />}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'images',
      }}
      {...rest}
    >
      <span>
        {i18n.getString(_TL_('You can add up to {{limit}} images to your ad.'), { limit: imageLimit })}
        {isMultimediaAd && i18n.getString(_TL_(' Required aspect ratios: 1.91:1 and 1:1. Minimum image upload dimensions: 703 x 368 pixels.'))}
      </span>
      <div className={classes.imageExperienceStyle}>
        <ImageListPortalContainerWithControlErrorHandling
          i18n={i18n}
          containerRef={containerRef}
          containerState={containerState}
          isLogos={false}
        />
        <PerfMaxImageSuggestionCarousel
          i18n={i18n}
          addImageCallback={addImageCallback}
          maxUploadNum={maxUploadNum}
        />
      </div>
    </ValidatedPanel>
  );
};

ImageListPortalContainerWithCarouselSection.propTypes = {
  expand: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  imageLimit: PropTypes.number.isRequired,
  maxUploadNum: PropTypes.number.isRequired,
  containerRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
  containerState: PropTypes.shape({}),
  addImageCallback: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    imageExperienceStyle: PropTypes.string,
  }),
  isMultimediaAd: PropTypes.bool,
};

ImageListPortalContainerWithCarouselSection.defaultProps = {
  containerState: {},
  classes: {},
  isMultimediaAd: true,
};
